import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { IonSlides } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class SlideService {
  constructor(@Inject(PLATFORM_ID) private platformId: any) {}

  async isEnd(slide: IonSlides) {
    if (slide) {
      if (!isPlatformBrowser(this.platformId)) {
        return false;
      }
      const reachedEnd = await slide.isEnd();
      return reachedEnd;
    }
  }

  comprobeCenter(data, slidesOpts) {
    if (data?.slider_position === 'center') {
      slidesOpts.centerInsufficientSlides = true;
    }
  }
}
